module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "shopCar_dialog",
    attrs: {
      "title": "采购车信息",
      "visible": _vm.shoCarAddFlag,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.shoCarAddFlag = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "shopCar_add",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SKU号",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.form.productId),
      callback: function($$v) {
        _vm.$set(_vm.form, "productId", $$v)
      },
      expression: "form.productId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "shopAddDesc"
  }, [_c('div', {
    staticClass: "descImg"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.form.imagePath,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.form.goodsName) + "\n          "), _c('span', {
    staticStyle: {
      "display": "block",
      "color": "#A2A2A2"
    }
  }, [_vm._v("规格: " + _vm._s(_vm.form.specName))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "block",
      "color": "#A2A2A2"
    }
  }, [_vm._v("SKU: " + _vm._s(_vm.form.productId))])])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input-number', {
    staticClass: "selectAdd",
    attrs: {
      "size": "mini",
      "min": 1,
      "label": "描述文字"
    },
    model: {
      value: (_vm.form.num1),
      callback: function($$v) {
        _vm.$set(_vm.form, "num1", $$v)
      },
      expression: "form.num1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收件人姓名",
      "label-width": _vm.formLabelWidth,
      "prop": "linkMan"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入收件人姓名"
    },
    model: {
      value: (_vm.form.linkMan),
      callback: function($$v) {
        _vm.$set(_vm.form, "linkMan", $$v)
      },
      expression: "form.linkMan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收件人电话",
      "label-width": _vm.formLabelWidth,
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入收件人电话"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收件人地址",
      "label-width": _vm.formLabelWidth,
      "prop": "homeAdress"
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.options,
      "change-on-select": "",
      "size": "265px",
      "placeholder": "请选择省/市/区"
    },
    model: {
      value: (_vm.form.homeAdress),
      callback: function($$v) {
        _vm.$set(_vm.form, "homeAdress", $$v)
      },
      expression: "form.homeAdress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "address",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自有订单号",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.ownerOrderSn),
      callback: function($$v) {
        _vm.$set(_vm.form, "ownerOrderSn", $$v)
      },
      expression: "form.ownerOrderSn"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.onCancle('ruleForm')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onCertain('ruleForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f9a10b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ShopCarAdd.vue
// module id = 519
// module chunks = 1